<template>
  <b-container>
    <b-form @submit="onSubmit" @reset="onReset">
      <div class="form-row">
        <b-col md="3" class="mt-3">
          <b-form-group
            id="grp1"
            label-cols="2"
            label="Scheme"
            label-size="sm"
            label-for="ipLoanType"
          >
            <b-select
              id="ipLoanType"
              class="form-control"
              value-field="LoanType"
              size="sm"
              text-field="SchemeName"
              :options="schemes"
              v-model="form.LoanType"
            ></b-select>
          </b-form-group>
        </b-col>
        <b-col class="mt-3" md="2">
          <b-form-group
            id="grp2"
            label-cols="3"
            label="District"
            label-size="sm"
            label-for="ipDistrict"
          >
            <b-select
              id="ipDistrict"
              :options="districts"
              value-field="DistID"
              text-field="DistName"
              required
              size="sm"
              :disabled="userDistrict != '00000000-0000-0000-0000-000000000000'"
              v-model="form.DistrictID"
              class="form-control"
            ></b-select>
          </b-form-group>
        </b-col>
        <b-col>
          <b-row>
            <b-col class="mt-3" md="4">
              <b-form-group
                id="grp3"
                label-cols="2"
                label="Status"
                label-size="sm"
                label-for="ipAPSts"
              >
                <b-select
                  id="ipAPSts"
                  class="form-control"
                  :options="approvalStatus"
                  value-field="Id"
                  text-field="ApplicationStatus"
                  required
                  size="sm"
                  v-model="form.ApplicationStatusID"
                ></b-select>
              </b-form-group>
            </b-col>
            <b-col md="5" class="mt-3">
              <b-form-group
                id="grp4"
                label-cols="4"
                label="Application No"
                label-size="sm"
                label-for="ipAppNum"
              >
                <b-form-input type="text" size="sm" id="ipAppNum" v-model="form.ApplicationNo" />
              </b-form-group>
            </b-col>
            <b-col class="mt-3" md="3">
              <b-button type="submit" size="sm" variant="primary" style="float:left">Search</b-button>
              <b-button variant="link" size="sm" v-b-modal.mdlAdvSearch style="font-size:0.8em">
                Advance Search
                <i class="fa fa-caret-square-down"></i>
              </b-button>
            </b-col>
          </b-row>
        </b-col>
      </div>
      <b-modal id="mdlAdvSearch" ref="mdlAdvSearch" size="lg" title="Advance Search" hide-footer>
        <b-form @submit="onSubmit" @reset="onReset">
          <div class="form-row">
            <b-col md="6" class="mt-3">
              <b-form-group
                id="grp11"
                label-cols="2"
                label="Scheme"
                label-size="sm"
                label-for="ipLoanType"
              >
                <b-select
                  id="ipLoanType"
                  class="form-control"
                  value-field="LoanType"
                  size="sm"
                  text-field="SchemeName"
                  :options="schemes"
                  v-model="form.LoanType"
                ></b-select>
              </b-form-group>
            </b-col>
            <b-col class="mt-3" md="6">
              <b-form-group
                id="grp2"
                label-cols="3"
                label="District"
                label-size="sm"
                label-for="ipDistrict"
              >
                <b-select
                  id="ipDistrict"
                  :options="districts"
                  value-field="DistID"
                  text-field="DistName"
                  required
                  size="sm"
                  :disabled="userDistrict != '00000000-0000-0000-0000-000000000000'"
                  v-model="form.DistrictID"
                  class="form-control"
                ></b-select>
              </b-form-group>
            </b-col>
          </div>
          <b-row>
            <b-col class="mt-3" md="6">
              <b-form-group
                id="grp13"
                label-cols="2"
                label="Status"
                label-size="sm"
                label-for="ipAPSts"
              >
                <b-select
                  id="ipAPSts"
                  class="form-control"
                  :options="approvalStatus"
                  value-field="Id"
                  text-field="ApplicationStatus"
                  required
                  size="sm"
                  v-model="form.ApplicationStatusID"
                ></b-select>
              </b-form-group>
            </b-col>
            <b-col md="6" class="mt-3">
              <b-form-group
                id="grp14"
                label-cols="4"
                label="Application No"
                label-size="sm"
                label-for="ipAppNum"
              >
                <b-form-input type="text" size="sm" id="ipAppNum" v-model="form.ApplicationNo" />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="mt-3" md="8">
              <b-form-group
                id="grp13"
                label-cols="3"
                label="Application Date"
                label-size="sm"
                label-for="ipAPDt"
              >
                <date-picker
                  v-model="appDate"
                  format="DD-MM-YYYY"
                  id="ipAPDt"
                  lang="en"
                  range
                  size="small"
                ></date-picker>
              </b-form-group>
            </b-col>
            <b-col md="4" class="mt-3">
              <b-form-group
                id="grp14"
                label-cols="4"
                label="Mobile No"
                label-size="sm"
                label-for="ipMobNum"
              >
                <b-form-input type="text" size="sm" id="ipMobNum" v-model="form.MobileNo" />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="mt-3">
              <b-button type="submit" size="sm" variant="success" class="float-right mx-2">Search</b-button>
              <b-button type="reset" size="sm" variant="secondary" style="float:right">Reset</b-button>
            </b-col>
          </b-row>
          <!-- <div class="form-row" v-if="1==2">
            <div class="form-group col-md-4">
              <label for="inputCity">Application No</label>
              <input type="text" class="form-control" id="inputCity" v-model="form.ApplicationNo">
            </div>
            <div class="form-group col-md-4">
              <label for="ipMobile">Mobile No</label>
              <input type="text" class="form-control" id="ipMobile" v-model="form.MobileNo">
            </div>
            <div class="form-group col-md-2" style="valign:bottom">
              <b-button type="submit" size="sm" variant="primary" style="margin-top:35px">Search</b-button>
            </div>
            <div class="form-group col-md-2">
              <b-button
                v-if="show && showbtn"
                variant="warning"
                size="sm"
                @click="scheduleBatch"
                style="margin-top:35px;float:right;margin-righ:10px"
              >Schedule Batch</b-button>
              <b-button
                variant="primary"
                size="sm"
                @click="convertToPdf"
                style="margin-top:35px;float:right;margin-righ:10px"
              >Create PDF</b-button>
              <b-button
                variant="primary"
                size="sm"
                @click="downloadExcel"
                style="margin-top:35px;float:right"
              >Download Excel</b-button>
            </div>
          </div>-->
        </b-form>
      </b-modal>
    </b-form>

    <hr />
    <b-row class="mb-2">
      <b-col md="3">
        <b-input-group>
          <b-form-input v-model="filter" placeholder="Type to Search" size="sm" />
          <b-input-group-append>
            <b-btn :disabled="!filter" @click="filter = ''" size="sm">Clear</b-btn>
          </b-input-group-append>
        </b-input-group>
      </b-col>

      <b-col md="3">
        <!-- <b-form-group horizontal label="Sort" class="mb-0" label-size="sm" label-cols="1">
              <b-input-group>
                <b-form-select v-model="sortBy" :options="sortOptions" size="sm">
                  <option slot="first" :value="null">-- none --</option>
                </b-form-select>
                <b-input-group-append>
                  <b-form-select :disabled="!sortBy" v-model="sortDesc" size="sm">
                    <option :value="false">Asc</option>
                    <option :value="true">Desc</option>
                  </b-form-select>
                </b-input-group-append>
              </b-input-group>
        </b-form-group>-->
        <p>Total Applications: {{totalRows}}</p>
      </b-col>
      <b-col>
        <b-button
          class="float-right mx-3"
          variant="outline-danger"
          size="sm"
          @click="convertToPdf"
          style="float:right; font-size:1em; font-color:red"
        >
          <i class="fa fa-file-pdf"></i>
        </b-button>
        <b-button
          variant="outline-success"
          size="sm"
          @click="downloadExcel"
          style="float:right; font-size:1em; font-color:green"
        >
          <i class="fa fa-file-excel"></i>
        </b-button>
        <b-button
          v-if="show && showbtn"
          variant="warning"
          size="sm"
          @click="scheduleBatch"
          style="float:right"
        >Schedule Batch</b-button>
        <!-- <b-button
          v-if="showExtend && (form.ApplicationStatusID==10 || form.ApplicationStatusID==23)"
          variant="warning"
          size="sm"
          @click="extendLoi"
          style="float:right;margin-right:10px"
        >Extend LOI</b-button> -->
      </b-col>
    </b-row>
    <b-table
      id="tblApplication"
      show-empty
      selectable
      select-mode="multi"
      head-variant="dark"
      empty-text="No Applications available."
      stacked="md"
      bordered
      striped
      :items="applications"
      :fields="fields"
      :current-page="currentPage"
      :per-page="perPage"
      :filter="filter"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      @filtered="onFiltered"
      @row-selected="onRowSelected"
      style="font-size:12px"
    >
      <template v-slot:cell(selected)="{ rowSelected }">
        <!-- <template slot="selected" slot-scope="row"> -->
        <template v-if="rowSelected">
          <span aria-hidden="true">&check;</span>
          <span class="sr-only">Selected</span>
        </template>
        <template v-else>
          <span aria-hidden="true">&nbsp;</span>
          <span class="sr-only">Not Selected</span>
        </template>
      </template>
      <template v-slot:cell(Sr)="row">{{((currentPage -1)*perPage) + row.index + 1}}</template>
      <template v-slot:cell(action)="row">
        <b-button
          size="sm"
          @click.stop="applyforScheme(row.item, row.index, $event.target,4)"
          class="mr-1 pt-0 pb-0"
          variant="success"
          v-b-tooltip.hover
          title="View Details"
        >View</b-button>
      </template>
      <template v-slot:cell(editDoc)="row">
        <b-button
          size="sm"
          @click.stop="editDocument(row.item, row.index, $event.target,4)"
          class="mr-1 pt-0 pb-0"
          variant="warning"
          v-b-tooltip.hover
          title="Edit Doc"
          v-if="isAdmin"
        >Docs</b-button>
      </template>
    </b-table>
    <b-row>
      <b-col md="8" class="my-1">
        <b-pagination
          :total-rows="totalRows"
          :per-page="perPage"
          v-model="currentPage"
          class="my-0"
          size="sm"
        />
      </b-col>
      <b-col md="4" class="my-1">
        <b-form-group horizontal label="Per page" class="mb-0" label-size="sm" :label-cols="6">
          <b-form-select :options="pageOptions" v-model="perPage" size="sm" />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form @submit="onSubmitBSC" @reset="onReset2" v-if="show && showsts">
          <b-row class="justify-content-md-center">
            <b-col md="9" sm="12" class="mt-2">
              <p style="font-size: 14px;color:#2284ab;">Beneficiary Selection Committee Report</p>
              <p></p>
              <div
                style="padding: 10px;
                                    border: 2px solid #c4c6be;
                                    border-radius: 15px;"
              >
                <div class="row">
                  <b-col md="4">
                    <b-form-group
                      id="exampleInputGroup2"
                      horizontal
                      label="Meeting Date*"
                      label-cols="4"
                      label-size="sm"
                      label-for="inpMtgDate"
                    >
                      <b-form-input
                        id="inpMtgDate"
                        type="date"
                        v-model="formBSC.MeetingDate"
                        required
                        size="sm"
                        placeholder="Meeting Date"
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                </div>
                <div class="row">
                  <div class="col-md-4">
                    <span
                      class="ln-eng"
                      style="font-size: 0.875rem;"
                    >Beneficiary Selection Committee Report</span>
                  </div>
                  <div class="col-md-4">
                    <b-form-file
                      ref="finp"
                      @change="onFileChange"
                      v-if="bscReportPath ==''"
                      accept=".jpg, .png, .gif"
                      size="sm"
                      required
                      v-model="bscReport"
                      class="mt-3"
                      plain
                    ></b-form-file>
                  </div>
                  <div class="col-md-4" v-if="bscReportPath!=''">
                    <a :href="getImgUrl2(bscReportPath)" target="_blank">
                      <img :src="getImgUrl(bscReportPath)" class="img-fluid" />
                    </a>
                    <b-button
                      size="sm"
                      style="margin-left:0.5rem"
                      @click.stop="deleteDocument2('PhotoPath', bscReportPath)"
                      class="mr-1 pt-0 pb-0"
                      variant="outline-danger"
                      v-b-tooltip.hover
                      title="Delete Document"
                    >
                      <i class="fa fa-trash" style="font-size:16px;color:red"></i>
                    </b-button>
                  </div>
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row class="mt-2 justify-content-md-center">
            <b-col md="5" sm="12" style="text-align:center">
              <Spinner size="32" message="Loading..." v-if="isLoadingFile"></Spinner>
              <b-alert
                :show="showDismissibleAlert"
                dismissible
                @dismissed="showDismissibleAlert=false"
                :variant="variant"
              >{{alertText}}</b-alert>
            </b-col>
            <b-col md="4" sm="12" style="text-align:right">
              <b-button type="submit" variant="primary" :disabled="!showBtn">Submit</b-button>
              <b-button type="reset" variant="danger">Reset</b-button>
            </b-col>
          </b-row>
        </b-form>
        <b-modal id="modalConfirm" title="Are you sure?" size="sm">
          <pre>{{ modalInfo }}</pre>
          <div slot="modal-footer">
            <b-button variant="danger" @click="modalConfirm" style="margin-left:5px">Delete</b-button>
            <b-button variant="info" @click="modalCancel" style="margin-left:5px">Cancel</b-button>
          </div>
        </b-modal>
      </b-col>
    </b-row>

    <div>
      <b-modal id="modalConfirm2" title="Schedule Batch" size="sm" hide-footer>
        <pre>Total Applications: {{ appCount }}</pre>
        <b-form @submit="onSubmit3" @reset="onReset3">
          <b-form-group
            id="iGpDt"
            horizontal
            label="Batch Date*"
            label-cols="4"
            label-size="sm"
            label-for="inpBatchDt"
          >
            <b-form-input
              id="inpBatchDt"
              type="date"
              v-model="formBatch.BatchDate"
              required
              size="sm"
              placeholder="Batch Date"
            ></b-form-input>
          </b-form-group>

          <b-form-group
            id="iGpTm"
            horizontal
            label="Batch Time*"
            label-cols="4"
            label-size="sm"
            label-for="inpBatchTime"
          >
            <b-form-input
              id="inpBatchTime"
              type="time"
              v-model="formBatch.BatchTime"
              required
              size="sm"
              placeholder="Batch Time"
            ></b-form-input>
          </b-form-group>
          <div slot="modal-footer">
            <b-button variant="danger" type="submit" style="margin-left:5px">Create Batch</b-button>
            <b-button variant="info" type="reset" style="margin-left:5px">Reset</b-button>
          </div>
        </b-form>
      </b-modal>
    </div>
  </b-container>
</template>

<script>
import apis from "@/apis";
import { mapState } from "vuex";
import lambda from "@/apis/lambda";
import * as _ from "lodash";
import axios from "axios";
import Spinner from "vue-simple-spinner";
import Formatter from "@/Formatter";
import * as jsPDF from "jspdf";
import "jspdf-autotable";
import XLSX from "xlsx";
import DatePicker from "vue2-datepicker";
import store from '../../store'

export default {
  props: ["userDistrictID", "userApprovalStatus", "userLoanType"],
  components: { Spinner, DatePicker },
  data() {
    return {
      showBtn: false,
      show: false,
      showsts: false,
      //showExtend: false,
      modalInfo: "",
      districts: [],
      schemes: [],
      pendingWithList: [
        "All",
        "DM",
        "DBSC",
        "AGM Project",
        "GM",
        "MD",
        "LOI",
        "Lapsed",
        "Disbursed",
        "Hold",
        "Rejected"
      ],
      approvalStatus: [],
      applications: [],
      bscReport: "",
      bscReportPath: "",
      appCount: 0,
      appDate: null,
      fields: [
        { key: "selected", label: "Selected" },
        { key: "Sr", label: "SrNo" },
        { key: "DistrictName", label: "District", sortable: true },
        { key: "LoanApplicationNo", label: "Application No", sortable: true },
        {
          key: "Createdate",
          label: "Application Date",
          sortable: true,
          formatter: "convertDateFormat"
        },
        { key: "AddharCardNumber", label: "Aadhar ID", sortable: true },
        { key: "FullName", label: "Applicant Name", sortable: true },
        { key: "Mobile", label: "Mobile No.", sortable: true },
        { key: "BusinessType", label: "Business Type", sortable: true },
        { key: "AmountDemanded", label: "Amount" },
        { key: "ApplicationStatus", label: "Status", sortable: true },
        {
          key: "LastStatusDate",
          label: "Last Action Date",
          sortable: true,
          formatter: "convertDateFormat"
        },
        { key: "action", label: "View" },
        { key:"editDoc", label: "Doc Edit"}
      ],
      selected: [],
      form: {
        DistrictID: "",
        ApplicationStatusID: 0,
        LoanType: 1,
        MobileNo: "",
        ApplicationNo: "",
        StartDate: "01-01-1970",
        EndDate: "01-01-1970"
      },
      formBatch: {
        BatchDate: null,
        BatchTime: null,
        ApplicationIDs: [],
        IsActive: true
      },
      showbtn: false,
      formBSC: {
        BSCID: 0,
        DistrictID: "",
        MeetingDate: null,
        ApprovalStatus: 13,
        ApprovalDoc: "",
        UserID: "",
        ApplicationIDs: []
      },
      selectedApplication: "",
      currentPage: 1,
      perPage: 50,
      totalRows: 0,
      pageOptions : [ 50, 100, 150, 200, 500],
      sortBy: null,
      sortDesc: false,
      filter: null,
      showDismissibleAlert: false,
      variant: "success",
      alertText: "",
      isLoading: false,
      isLoadingFile: false,
      isAdmin:false
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key };
        });
    },
    userDistrict() {
      return this.$store.getters.getUserDistrict;
    }
  },
  watch: {
    userDistrictId(newvalue, oldvalue) {
      this.form.DistrictID = newvalue;
      this.getApplications();
    }
  },
  methods: {
    convertDateFormat(inDate) {
      return Formatter.convertDateFormat(inDate);
    },
    onSubmit3(evt) {
      evt.preventDefault();

      this.showDismissibleAlert = false;
      var userinfo = this.$store.getters.loggedUser;
      var LoginID = userinfo.UserId;
      this.formBatch.LoginID = LoginID;

      //console.log("SELECTED", this.selected);
      for (var i = 0; i < this.selected.length; i++) {
        //loop through the array

        this.formBatch.ApplicationIDs.push(this.selected[i].LoanApplicationID);
      }

      // this.selected.forEach(function(data, index) {
      //   this.formBatch.ApplicationIDs.push(Object.values(data.ApplicationID));
      // });
      let promise = apis.createBatch(this.formBatch);

      promise
        .then(response => {
          //console.log(response);
          if (response.status == 200) {
            this.alertText = "Batch Created Successfully";
            this.variant = "success";
            this.showDismissibleAlert = true;
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
          this.isLoading = false;
        })
        .catch(err => {
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.isLoading = false;
        });
    },
    onReset3(evt) {},
    onRowSelected(items) {
      this.selected = items;
    },
    selectAllRows() {
      this.$refs.selectableTable.selectAllRows();
    },
    clearSelected() {
      this.$refs.selectableTable.clearSelected();
    },
    onSubmitBSC(evt) {
      evt.preventDefault();
      this.showBtn = false;
      this.showDismissibleAlert = false;
      if (this.formBSC.ApprovalDoc == "") {
        this.alertText =
          "Approval File is not yet Uploaded. Please check the file icon before submit.";
        this.showDismissibleAlert = true;
        return;
      }
      var userinfo = this.$store.getters.loggedUser;
      var LoginID = userinfo.UserId;
      this.formBSC.UserID = LoginID;
      this.formBSC.DistrictID = this.form.DistrictID;

      //console.log("SELECTED", this.selected);

      for (var i = 0; i < this.selected.length; i++) {
        //loop through the array

        this.formBSC.ApplicationIDs.push(this.selected[i].LoanApplicationID);
      }

      //console.log(this.formBSC);
      // this.selected.forEach(function(data, index) {
      //   this.form.ApplicationIDs.push(Object.values(data.ApplicationID));
      // });

      let promise = apis.UpdateBSCDetails(this.formBSC);

      promise
        .then(response => {
          //console.log(response);
          if (response.status == 200) {
            this.alertText = "Data Saved Successfully";
            this.variant = "success";
            this.showDismissibleAlert = true;
            this.ResetBSCForm();
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
            this.showBtn = false;
          }
          this.isLoading = false;
        })
        .catch(err => {
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.isLoading = false;
          this.showBtn = false;
        });
    },
    onReset2(evt) {
      evt.preventDefault();
    },
    ResetBSCForm() {
      this.$refs.finp.reset();
      this.bscReportPath = "";
      this.formBSC = {
        BSCID: 0,
        DistrictID: "",
        MeetingDate: null,
        ApprovalStatus: 13,
        ApprovalDoc: "",
        UserID: "",
        ApplicationIDs: []
      };
    },
    deleteDocument(item, index, button) {
      //console.log(item);
      this.selecteObj.Document = item.Document;
      this.selecteObj.Path = item.Path;

      let info = "You want to delete record for:" + "\n" + item.Document;
      this.modalInfo = info;
      this.$root.$emit("bv::show::modal", "modalConfirm");
    },
    scheduleBatch() {
      this.appCount = this.selected.length;
      if (this.appCount == 0) {
        alert("Please select Applications for Scheduling");
        return;
      }
      this.$root.$emit("bv::show::modal", "modalConfirm2");
    },
    modalCancel() {
      this.selecteObj.Document = "";
      this.selecteObj.Path = "";
      this.$root.$emit("bv::hide::modal", "modalConfirm");
    },

    modalConfirm() {
      this.form.UserLoanDocuments[this.selecteObj.Document] = "";

      var userinfo = this.$store.getters.loggedUser;
      var LoginID = userinfo.UserId;
      //   var filename =   this.Photo.name;
      this.form.LoginID = LoginID;
    },
    onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;

      if (!files.length) return;

      this.isLoadingFile = true;

      var strings = files[0].name.split(".");
      if (strings.length > 0) {
        var extn = strings[strings.length - 1].toLowerCase();
      }

      if (extn != "jpeg" && extn != "png" && extn != "jpg" && extn != "pdf") {
        this.showDismissibleAlert = true;
        this.alertText = "Wrong File Input";
        this.variant = "warning";
        this.$refs.finp.reset();
        this.isLoadingFile = false;
        return;
      }

      let dt = Date.now();
      var filetype = files[0].type;
      var filepath = "msobcfdc_bsc"+"!!~~!!"+"bsc_" + dt + "." + extn;
      var orignalfilepath="bsc_" + dt + "." + extn;
     // let promisefoto = lambda.getSignedURL("msobcfdc_bsc", filepath, filetype);
      let data = new FormData();
      let file = e.target.files[0];
       
      data.append('file', file,filepath);
      // promisefoto
      //   .then(response => {
      //     let signedUrl = response;
      //     var options = {
      //       headers: {
      //         "Access-Control-Allow-Origin": "*",
      //         "Content-Type": files[0].type
      //       }
      //     };
      //     return axios.put(signedUrl, files[0], options);
      //   })
      let config = {
      headers: {
        'Content-Type': 'multipart/form-data',
        "Access-Control-Allow-Origin": "*",
         "Authorization": "Bearer " + store.getters.authToken,
      }
    }
    debugger;
      axios.post('https://api.msobcfdc.in/api/LoanDisbursement/UploadSactionLetter', data, config)
        .then(res => {
          if (res.status == 200) {
            this.formBSC.ApprovalDoc = orignalfilepath;
            this.showBtn = true;
          } else {
            this.variant = "warning";
            this.alertText = "Error in uploading Image";
            this.showDismissibleAlert = true;
          }
          this.isLoadingFile = false;
        })
        .catch(err => {
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.isLoadingFile = false;
        });
    },
    applyforScheme(item, index, button, n) {
      this.$store.dispatch("setScheme", {
        SchemeID: item.SchemType,
        LoanType: item.LoanType,
        GroupID: item.GroupID
      });
      if (item.LoanType == 1) {
        this.$router.push({
          name: "ProfileApproval",
          params: {
            UserID: item.UserID,
            ApplicationStatus: this.form.ApplicationStatusID
          }
        });
      } else if (item.LoanType == 2) {
        this.$router.push({
          name: "GroupProfileApproval",
          params: {
            UserID: item.UserID,
            ApplicationStatus: this.form.ApplicationStatusID
          }
        });
      } else if (item.LoanType == 3) {
        this.$router.push({
          name: "ProfileApproval",
          params: {
            UserID: item.UserID,
            ApplicationStatus: this.form.ApplicationStatusID
          }
        });
      }
    },
    editDocument(item, index, button, n){
      this.$router.push({
        name:"DocEdit",
        params: {
            UserID: item.UserID,
            ApplicationStatus: this.form.ApplicationStatusID
          }
      })
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    getDistricts(stateid) {
      let promise = apis.getDistricts(stateid);

      promise
        .then(response => {
          if (response.status == 200) {
            this.districts = response.body;
            this.districts.unshift({
              DistID: "00000000-0000-0000-0000-000000000000",
              DistName: "All"
            });

            this.isLoading = false;
            //this.$router.push("/");
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
        })
        .catch(err => {
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
        });
    },
    getApprovalStatus() {
      let promise = apis.getApplicationStatusMstr();
      promise
        .then(response => {
          if (response.status == 200) {
            //let rspns = response.body;
            //this.$store.dispatch("setSchemeList", rspns);
            this.approvalStatus = response.body;
          } else {
            this.alertText =
              "Unable to Load Approval Status List, " + response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
          this.isLoading = false;
        })
        .catch(err => {
          this.alertText =
            "Unable to Load Approval Status List, " + err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.isLoading = false;
        });
    },
    getSchemes() {
      let promise = apis.getSchemes();

      promise
        .then(response => {
          if (response.status == 200) {
            //let rspns = response.body;
            //this.$store.dispatch("setSchemeList", rspns);
            this.schemes = response.body;
          } else {
            this.alertText = "Unable to Load Scheme List, " + response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
          this.isLoading = false;
        })
        .catch(err => {
          this.alertText = "Unable to Load Scheme List, " + err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.isLoading = false;
        });
    },
    onSubmit(evt) {
      evt.preventDefault();

      if (this.appDate != null) {
        this.form.StartDate = Formatter.convertDateFormatYMD(this.appDate[0]);
        this.form.EndDate = Formatter.convertDateFormatYMD(this.appDate[1]);
      } else {
        this.form.StartDate = "0001-01-01";
        this.form.EndDate = "0001-01-01";
      }

      this.getApplicationsSub();
    },

    getApplications() {
      //let userDistrict = this.$store.getters.getUserDistrict;
      if (this.userDistrict != "00000000-0000-0000-0000-000000000000") {
        this.form.DistrictID = this.userDistrict;
      }
      // else {
      //   this.form.DistrictID = this.$store.getters.getDistrict;
      // }
      // this.form.LoanType = this.$store.getters.getLoanType;
      // this.form.ApplicationStatusID = this.$router.params.userLoanType;
      this.getApplicationsSub();
    },

    getApplicationsSub() {
      this.isLoading = true;
      this.showDismissibleAlert = false;

      if (this.form.ApplicationStatusID == 2) {
        this.showsts = true;
      } else {
        this.showsts = false;
      }

      if (this.form.ApplicationStatusID == 1) {
        this.showbtn = true;
      } else {
        this.showbtn = false;
      }

      this.$store.dispatch("setSearchForm", this.form);
      let promise = apis.ReadApplicationList(this.form);

      promise
        .then(response => {
          //console.log(response);
          if (response.status == 200) {
            this.applications = response.body;
            this.totalRows = this.applications.length;
            var userinfo = this.$store.getters.loggedUser;
            // if (this.form.ApplicationStatusID == 10 && userinfo.RoleID == 4) {
            //   this.showExtend = true;
            // } else {
            //   this.showExtend = false;
            // }
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
          this.isLoading = false;
        })
        .catch(err => {
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.isLoading = false;
        });

      this.$refs.mdlAdvSearch.hide();
      //console.log(this.selectedDistrict);
    },
    onReset(evt) {
      evt.preventDefault();
      this.form = {
        DistrictID: "",
        ApplicationStatusID: 0,
        LoanType: 1,
        MobileNo: "",
        ApplicationNo: "",
        StartDate: null,
        EndDate: null
      };
    },
    convertToPdf() {
      var pdf = new jsPDF("l", "pt");
      var columns = [
        { dataKey: "DistrictName", title: "District" },
        { dataKey: "LoanApplicationNo", title: "Application No" },
        {
          dataKey: "Createdate",
          title: "Application Date"
        },
        { dataKey: "BusinessType", title: "Business Type" },
        { dataKey: "AddharCardNumber", title: "Aadhar ID" },
        { dataKey: "FullName", title: "Applicant Name" },
        { dataKey: "Mobile", title: "Mobile No." },
        { dataKey: "AmountDemanded", title: "Amount" },
        { dataKey: "ApplicationStatus", title: "Status" }
      ];
      pdf.text("MSOBCFDC Loan Applications", 25, 30);
      var vc = this;
      pdf.autoTable(columns, vc.applications, {
        didParseCell(data) {
          if (data.cell.section != "head") {
            switch (data.column.dataKey) {
              case "Createdate":
                data.cell.text = vc.convertDateFormat(data.cell.text);
                break;
            }
          }
        }
      });
      pdf.save("Applications.pdf");
    },
    async downloadExcel() {
      var columns = [
        "District",
        "Application No",
        "Application Date",
        "Business Type",
        "Aadhar ID",
        "Applicant Name",
        "Mobile No.",
        "Amount",
        "Status",
        "Last Action Date"
      ];

      let app_data = [];

      await this.applications.forEach(element => {
        let obj = {
          District: "",
          "Application No": "",
          "Application Date": null,
          "Business Type": null,
          "Aadhar ID": "",
          "Applicant Name": "",
          "Mobile No.": "",
          Amount: 0,
          Status: ""
        };

        obj.District = element.DistrictName;
        obj["Application No"] = element.LoanApplicationNo;
        obj["Application Date"] = this.convertDateFormat(element.Createdate);
        obj["Aadhar ID"] = element.AddharCardNumber;
        obj["Applicant Name"] = this.titleCase(element.FullName);
        obj["Business Type"] = this.titleCase(element.BusinessType);
        obj["Mobile No."] = element.Mobile;
        obj["Amount"] = element.AmountDemanded;
        obj["Status"] = element.ApplicationStatus;
        obj["Last Action Date"] = this.convertDateFormat(
          element.LastStatusDate
        );

        app_data.push(obj);
      });

      var vc = this;
      var wb = XLSX.utils.book_new();
      var ws = XLSX.utils.json_to_sheet(app_data, { header: columns });
      ws["!cols"] = [
        { wpx: 125 },
        { wpx: 180 },
        { wpx: 120 },
        { wpx: 105 },
        { wpx: 105 },
        { wpx: 220 },
        { wpx: 90 },
        { wpx: 70 },
        { wpx: 70 }
      ];
      XLSX.utils.book_append_sheet(wb, ws, "Applications");
      XLSX.writeFile(wb, "Application.xlsx");
    },
    titleCase(str) {
      if ((str != null) & (str != undefined)) {
        return str
          .trim()
          .toLowerCase()
          .split(" ")
          .map(function(word) {
            if (word) {
              return word.replace(word[0], word[0].toUpperCase());
            } else {
              return "";
            }
          })
          .join(" ");
      }
    },
    extendLoi(evt) {
      evt.preventDefault();
      if (this.selected.length == 0) {
        this.$dialog.alert("Please select application");
        return;
      }
      var appform = {
        ApplicationIDs: [],
        CreatedUser: this.$store.getters.loggedUser.UserID
      };

      for (var i = 0; i < this.selected.length; i++) {
        appform.ApplicationIDs.push(this.selected[i].LoanApplicationID);
      }
      var t = this;
      this.$dialog
        .prompt(
          {
            title: "Confirm LOI Extension",
            body:
              "A New LOI will be issued for the selected Application(s), Do you want to Continue?"
          },
          {
            promptHelp: 'Provide Remarks and click "[+:okText]"',
            okText: "Extend LOI",
            cancelText: "Cancel",
            loader: false
          }
        )
        .then(function(dialog) {
          if (dialog.data) {
            appform.remarks = dialog.data;
          } else {
            t.$dialog.alert("Please enter Remarks");
            return;
          }
          return apis.ExtendLoi(appform);
        })
        .then(response => {
          if (response != undefined) {
            if (response.status == 200) {
              this.$dialog.alert(
                "New LOI Issued for the Selected Applications"
              );
              t.getApplicationsSub();
            } else {
              this.$dialog.alert("Unable to save changes");
            }
          }
        })
        .catch(err => {
          if (err != false) {
            this.$dialog.alert("Error while saving data");
          }
        });
    }
  },
  mounted() {
    let frm = this.$store.getters.getAppSearchForm;

    if (frm != {} && frm.ApplicationStatusID != undefined) {
      this.form = frm;
    } else {
      this.form.DistrictID = this.$store.getters.getDistrict;
      this.form.ApplicationStatusID = this.$store.getters.getAppStatus;
      this.form.LoanType = this.$route.params.userLoanType;
    }
    this.getDistricts("BB62F7B0-748D-4E64-AD4F-8EF691431FA1");
    this.getSchemes();
    this.getApprovalStatus();
    this.getApplications();

    var userinfo = this.$store.getters.loggedUser;

    if (userinfo.RoleID == 2) {
      this.show = true;
      this.isAdmin = false;
    } 
    else if(userinfo.RoleID == 1){
      this.isAdmin = true;
      this.show = false;
    }
    else {
      this.show = false;
      this.isAdmin = false;
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Admin/Applications.vue